import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { TranslateModule } from '@ngx-translate/core';
import { AutocompleteSelectorModule } from '../../autocomplete-selector/autocomplete-selector.module';
import { ChipSelectorModule } from '../../chip-selector/chip-selector.module';
import { ConfirmButtonModule } from '../../confirm-button/confirm-button.module';
import { ShareByAppComponent } from './components/share-by-app/share-by-app.component';
import { ShareByEmailComponent } from './components/share-by-email/share-by-email.component';
import { ShareByReferingVetComponent } from './components/share-by-refering-vet/share-by-refering-vet.component';
import { ShareStudyComponent } from './share-study.component';
import { ShareRevocationComponent } from './components/share-revocation/share-revocation.component';
import { MatListModule } from '@angular/material/list';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
  declarations: [ShareStudyComponent, ShareByAppComponent, ShareByEmailComponent, ShareByReferingVetComponent, ShareRevocationComponent],
  imports: [
    CommonModule,
    TranslateModule,
    AutocompleteSelectorModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatListModule,
    MatIconModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatRadioModule,
    MatSlideToggleModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    ChipSelectorModule,
    ConfirmButtonModule
  ],
})
export class ShareStudyModule {}
